const UAEvents = function () {

    function _click(that, theOriginLevel2, theActionCause, tilePositionSelector, parentSelector, catalog) {
        let $thisTile, documentTitle, documentPosition, documentUri, documentUriHash, sourceName, contentIDValue, brand, price, name, category, genericId, rankingModifier, queryPipeline,
            searchQueryUid, originLevel1, splitTestRunName, splitTestRunVersion, nbOfResults;

        const contentIDKey = 'permanentid';
        const language = $('html').attr('lang');
        const userAgent = navigator.userAgent;
        const actionCause = theActionCause;
        let originContext = 'Search';
        let originLevel2 = theOriginLevel2;

        if (theOriginLevel2 === 'product') {
            $thisTile = $(that).parents(parentSelector);
            documentTitle = $thisTile.find('.head__title').text();
            contentIDValue = $(that).parents(parentSelector).attr('data-product-code');
            brand = $thisTile.attr('data-product-brand');
            price = $thisTile.find('[data-main-price]').attr('data-main-price');
            name = $thisTile.attr('data-product-name');
            category = $thisTile.attr('data-ec-category');
            genericId = $thisTile.attr('data-generic-id');
            let aislesPath = $thisTile.attr('data-aisles-path');
            if (typeof aislesPath !== 'undefined') {
                originLevel2 = aislesPath;
            }

            nbOfResults = typeof productsNumberOfResults !== 'undefined' ? productsNumberOfResults : 30;
            let tileIndex = $thisTile.attr('data-index');
            if (typeof tileIndex !== 'undefined') {
                documentPosition = tileIndex;
            } else {
                documentPosition = _tilePosition($thisTile, tilePositionSelector, '.product-page-nav-standard .ppn--pagination .current', nbOfResults, catalog);
            }

            let context = $thisTile.attr('data-origin-context');
            if (typeof context !== 'undefined') {
                originContext = context;
            }

        } else if (theOriginLevel2 === 'recipe') {
            nbOfResults = typeof recipesNumberOfResults !== 'undefined' ? recipesNumberOfResults : 25;
            $thisTile = $(that);
            documentTitle = $thisTile.find('.content__top h3').text();
            documentPosition = _tilePosition($thisTile, tilePositionSelector, '.flex-parent .ppn--pagination .current', nbOfResults, catalog);
        } else if (theOriginLevel2 === 'article') {
            $thisTile = $(that);
            documentTitle = $thisTile.attr('data-title');
            documentPosition = _tilePosition($thisTile, tilePositionSelector, '.flex-parent .ppn--pagination .current', 10, catalog);
        } else {
            return false;
        }
        queryPipeline = $thisTile.attr('data-query-pipeline');
        searchQueryUid = $thisTile.attr('data-search-query-uid');
        rankingModifier = $thisTile.attr('data-ranking-modifier');
        originLevel1 = $thisTile.attr('data-origin-level1');
        documentUri = $thisTile.attr('data-uri');
        documentUriHash = $thisTile.attr('data-uri-hash');
        sourceName = $thisTile.attr('data-source-name');
        splitTestRunName = $thisTile.attr('data-split-test-run-name');
        splitTestRunVersion = $thisTile.attr('data-split-test-run-version');

        if (sourceName === undefined) {
            return false;
        }

        let clickEventData = {
            language: language,
            userAgent: userAgent,
            documentPosition: documentPosition,
            documentTitle: documentTitle,
            documentUri: documentUri,
            documentUriHash: documentUriHash,
            sourceName: sourceName,
            queryPipeline: queryPipeline,
            originContext: originContext,
            originLevel2: originLevel2,
            actionCause: actionCause,
            searchQueryUid: searchQueryUid,
            rankingModifier: rankingModifier,
            originLevel1: originLevel1,
            splitTestRunName: splitTestRunName,
            splitTestRunVersion: splitTestRunVersion,
            customData: {
                contentIDKey: contentIDKey,
                contentIDValue: contentIDValue,
                brand: brand,
                price: price,
                name: name,
                context_website: context_website,
                category: category,
                group: genericId,
                variant: genericId
            }
        }

        $.ajax({
            url: vitrineUrl + '/' + lang + '/analytics/click',
            type: 'POST',
            contentType: 'application/json',
            dataType: 'html',
            data: JSON.stringify(clickEventData),
            cache: false
        });
    }

    function _defineDocument(tilePositionSelector, catalog) {
        $(tilePositionSelector + ' .product-details-link, ' + tilePositionSelector + ' .pt__visual a').on('click contextmenu', function () {
            UAEvents.click(this, 'product', 'documentOpen', tilePositionSelector, '.tile-product', catalog);
        });
        $(tilePositionSelector + ' .btn--displayFlavours').click(function () {
            UAEvents.click(this, 'product', 'documentOpen', tilePositionSelector, '.tile-product', catalog);
        });
        $(tilePositionSelector + ' .pt__content--actions .action__favorite').click(function () {
            UAEvents.click(this, 'product', 'documentOpen', tilePositionSelector, '.tile-product', catalog);
        });
        $(tilePositionSelector + ' .pt__content--actions .cart-plus').click(function () {
            UAEvents.click(this, 'product', 'documentOpen', tilePositionSelector, '.tile-product', catalog);
        });
        $(tilePositionSelector + ' .pt__content--actions .plus-addToCart').click(function () {
            UAEvents.click(this, 'product', 'documentOpen', tilePositionSelector, '.tile-product', catalog);
        });
        $(tilePositionSelector + ' .pt__content--actions .minus-addToCart').click(function () {
            UAEvents.click(this, 'product', 'documentOpen', tilePositionSelector, '.tile-product', catalog);
        });
    }

    function _defineDocumentClick(selParent, tilePositionSelector, origin, catalog) {
        $(selParent + tilePositionSelector).click(function () {
            UAEvents.click(this, origin, 'documentOpen', selParent, '.tile-product', catalog);
        });
    }

    function _tilePosition(tile, selParent, tilePositionSelector, numberOfTile, catalog) {
        let $tiles = $(selParent);
        let position;
        if ($tiles.length) {
            let pageNumber = $(tilePositionSelector).text();
            if (catalog) {
                let positionInPage = $.inArray(tile[0], $tiles) + 1;
                position = positionInPage + ((pageNumber - 1) * (numberOfTile));
            } else {
                position = $.inArray(tile[0], $tiles) + 1;
            }
        }
        return position;
    }

    return {
        click: _click,
        defineDocument: _defineDocument,
        defineDocumentClick: _defineDocumentClick
    };
}();